import Axios from 'axios';
import Config from '../config';
import Store from '../store';

const client = Axios.create({ baseURL: Config.api });

client.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + Store.state.token;
  return config;
}, function (error) {
  return Promise.reject(error);
});


client.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
  }

  return Promise.reject(error);
});

export default client;
